import { useQueryClient } from "@tanstack/react-query"

import { TParadiseLLMPromptsQueryParams } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"

export const paradiseLLMPromptsKeys = {
  all() {
    return ["paradiseLLMPrompts"] as const
  },

  promptslists() {
    return [...this.all(), "list"] as const
  },

  promptsList(filter?: TParadiseLLMPromptsQueryParams) {
    if (!filter) {
      return [...this.promptslists()] as const
    }

    return [...this.promptslists(), filter] as const
  },

  prompts() {
    return [...this.all(), "prompt"] as const
  },

  prompt(id: string) {
    return [...this.prompts(), id] as const
  },

  categories() {
    return [...this.all(), "categories"] as const
  },

  changeNotes(promptId: string, prompt: string) {
    return [...this.all(), "changeNotes", promptId, prompt] as const
  },
} as const

export function useParadiseLLMPromptsCache() {
  const queryClient = useQueryClient()

  function invalidateParadiseLLMPromptsList() {
    return queryClient.invalidateQueries({
      queryKey: paradiseLLMPromptsKeys.promptsList(),
    })
  }

  function invalidateParadiseLLMPrompt(id: string) {
    return queryClient.invalidateQueries({
      queryKey: paradiseLLMPromptsKeys.prompt(id),
    })
  }

  function invalidateAllParadiseLLMPrompts() {
    return queryClient.invalidateQueries({
      queryKey: paradiseLLMPromptsKeys.all(),
    })
  }

  return {
    invalidateParadiseLLMPromptsList,
    invalidateParadiseLLMPrompt,
    invalidateAllParadiseLLMPrompts,
  }
}
